/* eslint-disable import/no-anonymous-default-export */
export default {
  "projectItem.name": "Name",
  "projectItem.version": "Revision",
  "projectItem.owner": "Eigentümer",
  "projectItem.description": "Beschreibung",
  "projectItem.updated_at": "Aktualisierungsdatum",
  "projectItem.created_at": "Datum",
  "projectItem.download": "Herunterladen",
  "projectItem.delete": "Löschen",
  "projectItem.folderRoot": "Stammordner",
  "projectItem.new_folder": "Neuer Ordner",
  "projectItem.upload": "Hochladen",
  "projectItem.add": "Datei hinzufügen",
  "projectItem.update": "Aktualisieren",
  "projectItem.input.remove": "Entfernen",
  "projectItem.input.required": "Pflichtfeld",
  "projectItem.menuItem.Download": "Herunterladen",
  "projectItem.menuItem.share": "Teilen",
  "projectItem.menuItem.details": "Details",
  "projectItem.menuItem.view": "Anzeigen",
  "projectItem.menuItem.personalize": "Anpassen",
  "projectItem.menuItem.personalize.folderColor": "Ordnerfarbe",
  "projectItem.search": "Suchen",
  "projectItem.listFile": "Dateiliste",
  "projectItem.revision.place.extern": "Externe Revision",
  "projectItem.revision.numeric.help":
    "Dateirevisionen müssen dem Muster R00, R01, R99 folgen.",
  "projectItem.revision.alphabetical.help":
    "Dateirevisionen müssen dem Muster RA, RB, RCZ folgen.",
  "projectItem.revision.doubleNumeric.help":
    "Dateirevisionen müssen dem Muster R00.00, R01.01, R99.99 folgen.",
  "projectItem.validation.description": "Geben Sie die Beschreibung ein",
  "projectItem.validation.revision": "Geben Sie die Revision ein",
  "projectItem.placeholder.description": "Inhaltsbeschreibung",
  "projectItem.placeholder.description.file": "Dateibeschreibung",
  "projectItem.placeholder.description.folder": "Ordnerbeschreibung",
  "projectItem.modal.send": "Senden",
  "projectItem.modal.cancel": "Abbrechen",
  "projectItem.modal.revisionInfo":
    "Beim Registrieren einer Datei mit einer neuen Revision wird sie automatisch ersetzt",
  "projectItem.error": "Ein Fehler ist aufgetreten",
  "projectItem.upload.dropText": "Dateien hierher ziehen",
  "projectItem.upload.dropHint": "Oder hier klicken und suchen",
  "projectItem.pathTaken": "Zurückgelegter Pfad",
  "projectItem.drawerDetails.title": "Details",
  "projectItem.drawerDetails.folder": "Ordnerdetails",
  "projectItem.drawerDetails.folderName": "Ordnername",
  "projectItem.drawerDetails.files": "Dateidetails",
  "projectItem.drawerDetails.fileName": "Dateiname",
  "projectItem.drawerDetails.owner": "Eigentümer",
  "projectItem.drawerDetails.from": "Von",
  "projectItem.drawerDetails.modified": "Geändert am",
  "projectItem.drawerDetails.lastVersions": "Letzte Versionen",
  "projectItem.drawerDetails.historic": "Verlauf",
  "projectItem.drawerDetails.ative": "Aktiv",
  "projectItem.drawerDetails.copy": "Kopiert",
  "projectItem.drawerDetails.downloadLastVersion":
    "Letzte Version herunterladen",
  "projectItem.drawerDetails.download.withoutRevision":
    "Die Revision wird bei diesem Download nicht in den Dateinamen einbezogen.",
  "projectItem.error.maxNameLength": "Name mit Größe über dem Zeichenlimit.",
  "projectItem.line1": "Verwalten Sie Ihre Projekte mit mehr",
  "projectItem.highlight1": "Organisation",
  "projectItem.and": "und",
  "projectItem.highlight2": "Sicherheit!",
  "projectItem.link": "Hier klicken",
  "projectItem.line3": "und haben Sie es auch in Ihrem Unternehmen.",
  "projectItem.headerTagline":
    "Verwalten Sie Ihre Projekte mit mehr Organisation und Sicherheit!",
  "projectItem.ctaJoinplace": "Joinplace entdecken",
};
